import { requestApi } from '@app/api';
import { withForm } from '@app/api/paths';

export function getFormById(formId: string) {
  return requestApi<{
    id: string;
    content: string;
    fileUrl: string;
    name: string;
    previewImage: string;
    overview: string;
    quote: string;
    source: {
      type: 'MODUSIGN' | 'EXPERT' | 'ORGANIZATION';
      name: string | null;
      description: string | null;
      site: string | null;
    };
    tags: Array<{ id: string; name: string }>;
  }>({
    url: withForm(`/forms/${formId}`),
    method: 'GET',
  }).then((res) => res.data);
}

export function requestForm(data: { name: string; category: string; purpose: string }) {
  return requestApi({
    url: withForm('/forms/request'),
    method: 'POST',
    credentials: true,
    data,
  });
}
